<template>
  <section class="section is-main-section">
    <div class="box has-text-centered">
      <b-icon icon="lock-outline" size="is-large" type="is-danger" />
      <h1 class="title is-4 mt-3">Acces interzis</h1>
      <p class="mb-4">Nu aveti permisiunea de a deschide aceasta pagina.</p>
      <router-link to="/" class="button is-primary">
        Inapoi la pagina de pornire
      </router-link>
    </div>
  </section>
</template>

<script>
export default {
  name: "Forbidden",
};
</script>
